import { render, staticRenderFns } from "./OnlineCommonList.vue?vue&type=template&id=55a96fe9&scoped=true&"
import script from "./OnlineCommonList.vue?vue&type=script&lang=js&"
export * from "./OnlineCommonList.vue?vue&type=script&lang=js&"
import style0 from "./OnlineCommonList.vue?vue&type=style&index=0&id=55a96fe9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a96fe9",
  null
  
)

export default component.exports